import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { RADIUS_1 } from '@Styles/constants/radius'

// Not applicable to BasicCardButton & BasicCard because they don't need an internal CardContent by default and they are 54px high
export const cardContentBase = (theme: Theme): SerializedStyles =>
  css({
    // TODO : gap: theme.spacing(1),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
    alignItems: 'center',
    display: 'flex',
    flex: '1 1',
    minHeight: rem(56),
  })

export const cardContentChildrenWrapperBase = css({
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1,
  // 34px is a magic number without needed pass the icon size
  width: 'calc(100% - 34px)',
})

export const bottomChild = css({
  minHeight: rem(32),
})

export const withHoverBottomChild = css({
  '&:hover': {
    borderRadius: `${RADIUS_1} ${RADIUS_1} 0 0`,
  },
})
